<template>
  <div>
    <!-- 會員中心首頁header begin-->
    <div class="container-fluid p-0 border-bottom text-mcf-color mcf-border-color">
      <div class="row no-gutters align-items-center" style="min-height: 48px;">
        <div class="col-3"></div>
        <div class="col-6 text-center">
          <img v-if="imageLoadingCompleted" class="mx-1 logo" :src="icon" alt="" @click="redirectBrandHomePage" />
          <span class="font-weight-bold mx-1 align-middle">{{ text }}</span>
        </div>
        <div class="col-3">
        </div>
      </div>
    </div>
    <!-- 會員中心首頁header end-->
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconLinkUrl: String,
    // 資料是否完成載入
    imageLoadingCompleted: Boolean,
  },
  methods: {
    // 導向品牌首頁
    redirectBrandHomePage() {
      window.location.href = this.iconLinkUrl;
    },
  },
};
</script>

<style>
.logo{ max-height: 40px; width: auto;}
</style>
